<template>
	<view class="order">
		<view class="container_h" :style="{height: 'calc(' + (navHeight + statusbarHeight) + 'px' + ' + 224rpx)'}">
			<view class="container_box">
				<view class="container_status" :style="{height: statusbarHeight + 'px'}"></view>
				<view class="container_head" :style="{height: navHeight + 'px'}">
					<uni-icons type="back" size="20" color="#fff" @click="go"></uni-icons>
					<text>退货换货详情</text>
					<text></text>
				</view>
			</view>
			<view class="container_h_info" :style="{ paddingTop: 'calc(' + (navHeight + statusbarHeight) + 'px' + ' + 20rpx)' }">
				<view class="container_h_info_label">等待商家审核</view>
				<view class="container_h_info_list">
					<view class="xian">
						<view class="xian_item">
							<view class="xian_item_y active"></view>
							<view class="xian_item_x active"></view>
						</view>
						<view class="xian_item">
							<view class="xian_item_y active"></view>
							<view class="xian_item_x"></view>
						</view>
						<view class="xian_item">
							<view class="xian_item_y"></view>
							<view class="xian_item_x"></view>
						</view>
						<view class="xian_item">
							<view class="xian_item_y"></view>
							<view class="xian_item_x"></view>
						</view>
						<view class="xian_item">
							<view class="xian_item_y"></view>
						</view>
					</view>
					<view class="label">
						<view class="label_item active">提交申请</view>
						<view class="label_item active">商家处理</view>
						<view class="label_item">退回商品</view>
						<view class="label_item">商家退款</view>
						<view class="label_item">退款成功</view>
					</view>
				</view>
			</view>
		</view>
		<!-- 商家退款 -->
		<view class="order_jijian">
			<view class="top">
				<text>换货成功</text>
				<text>您已签收换货商品，完成换货</text>
			</view>
		</view>
		<!-- 拒绝退款 -->
		<view class="order_refuse">
			<text>商家拒绝了您的申请</text>
			<text>说明：与买家协商不一致</text>
			<text>若您的问题未解决，可在有效期内再次申请</text>
		</view>
		<!-- 退款成功 -->
		<view class="order_success">
			<view class="order_success_top">
				<view class="order_success_top_left">退款成功</view>
				<view class="order_success_top_right">
					<text>¥</text>
					<text>74</text>
					<text>.98</text>
				</view>
			</view>
			<view class="order_success_info">
				<text>2022-12-16 10:26</text>
				<text>因商家超时未处理，交易支持退款</text>
			</view>
			<view class="order_success_item">
				<view class="order_success_item_label">原路退回</view>
				<view class="order_success_item_price">
					<text>¥</text>
					<text>74</text>
					<text>.98</text>
				</view>
			</view>
			<view class="order_success_item">
				<view class="order_success_item_label">退回优惠券</view>
				<view class="order_success_item_price">
					<text>¥</text>
					<text>5</text>
				</view>
			</view>
		</view>
		<!-- 商家退款 -->
		<view class="order_jijian">
			<view class="top">
				<text>请等待商家处理</text>
				<text>您已成功发起退货退款申请，请耐心等待商家处理</text>
			</view>
			<view class="content">
				<view class="content_lefta">
					<text><text>已签收</text>深圳市福田区赛格科技园公司 已签收格科技园公司 已签收</text>
					<text>丹鸟KD  运单号：380808403579340</text>
				</view>
				<uni-icons type="forward" size="20" color="#999999"></uni-icons>
			</view>
		</view>
		<!-- 退回商品 -->
		<view class="order_jijian">
			<view class="label">寄件详情</view>
			<view class="content">
				<view class="content_left">
					<text><text>运输中</text>【上海市】快件已到达【上海浦西转运中心</text>
				</view>
				<uni-icons type="forward" size="20" color="#999999"></uni-icons>
			</view>
		</view>
		<view class="order_info">
			<view class="order_info_item">
				<view class="order_info_item_top">
					<text>收货人：kesson睡不着</text>
					<text>15789347769</text>
				</view>
				<view class="order_info_item_bottom">
					<text>广东省 深圳市 福田区赛格科技园103栋 7楼 </text>
					<text>复制</text>
				</view>
			</view>
			<view class="order_info_item1">
				<view class="order_info_item1_left">
					<text>我已寄出</text>
					<text>点击填写快递单号</text>
				</view>
				<view class="order_info_item1_sub" @click="jump">填写单号</view>
			</view>
		</view>
		<view class="order_shop">
			<view class="order_shop_label">退款信息</view>
			<view class="order_shop_info">
				<view class="order_shop_info_img">
					<image src="@/static/uni.png" mode="widthFix"></image>
				</view>
				<view class="order_shop_info_right">
					<view class="order_shop_info_right_top">
						<view class="title">清澄白河马克杯-节日版</view>
						<view class="price">
							<text>¥</text>
							<text>79</text>
							<text>.98</text>
						</view>
					</view>
					<view class="order_shop_info_right_bottom">
						<text>白色</text>
						<text>x1</text>
					</view>
				</view>
			</view>
			<view class="order_shop_list">
				<view class="order_shop_list_item">
					<text class="label">退款原因</text>
					<text class="time">退运费</text>
				</view>
				<view class="order_shop_list_item">
					<text class="label">退款金额</text>
					<text class="time">¥74.98</text>
				</view>
				<view class="order_shop_list_item">
					<text class="label">申请时间</text>
					<text class="time">2022-12-29 10:22</text>
				</view>
				<view class="order_shop_list_item">
					<text class="label">订单编号</text>
					<view class="copy">
						<text>204802845195194980</text>
						<text>|</text>
						<text>复制</text>
					</view>
				</view>
			</view>
		</view>
		<view class="order_footer">
			<view class="order_footer_left"></view>
			<view class="order_footer_right">
				<view class="order_footer_right_btn">联系客服</view>
				<view class="order_footer_right_btn margin">撤销申请</view>
				<view class="order_footer_right_btn">客服介入</view>
				<view class="order_footer_right_btn margin">重新申请</view>
			</view>
		</view>
		<view class="order_zw"></view>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				cates: [
					{ name: '价格有点贵', id: 1 },
					{ name: '规格/款式/数量拍错', id: 2 },
					{ name: '暂时不需要', id: 3 },
					{ name: '其他', id: 4 }
				],
				from: {
					name: '',
					val: ''
				},
				current: 0
			}
		},
		computed: {
			...mapState(['statusbarHeight', 'navHeight'])
		},
		methods: {
			go() {
				uni.navigateBack({ delta: 1 });
			},
			jump() {
				uni.navigateTo({
					url: '/pages/expressDelivery/index'
				});
			},
			openOrder() {
				this.$refs.popup1.open('bottom')
			},
			close() {
				this.$refs.popup1.close()
			},
			changeCate(index) {
				this.current = index
			},
			define() {
				this.from.name = this.cates[this.current].name
				this.from.val = this.cates[this.current].id
				this.$refs.popup.close()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.order {
		width: 100%;
		.container_h {
			width: 100%;
			background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
			.container_box {
				width: 100%;
				position: fixed;
				left: 0;
				top: 0;
				z-index: 9;
				.container_status {
					width: 100%;
				}
				.container_head {
					width: 100%;
					padding: 0 32rpx;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: space-between;
					background-color: rgba(0, 0, 0, 0);
					text {
						font-size: 34rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
						margin-right: 20rpx;
					}
				}
			}
			.container_h_info {
				width: 100%;
				box-sizing: border-box;
				padding: 0 32rpx;
				display: flex;
				flex-direction: column;
				.container_h_info_label {
					font-size: 40rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #FFFFFF;
				}
				.container_h_info_list {
					margin-top: 38rpx;
					display: flex;
					flex-direction: column;
					.xian {
						display: flex;
						align-items: center;
						.xian_item {
							flex: 1;
							height: 20rpx;
							display: flex;
							align-items: center;
							justify-content: center;
							position: relative;
							.active {
								background-color: #FFFFFF !important;
							}
							.xian_item_y {
								width: 20rpx;
								height: 20rpx;
								background: rgba(255,255,255,0.7);
								border-radius: 50%;
							}
							.xian_item_x {
								position: absolute;
								left: 50%;
								top: 50%;
								transform: translate(0, -50%);
								width: 132rpx;
								height: 2rpx;
								background-color: rgba(255,255,255,0.7);
							}
						}
					}
					.label {
						width: 100%;
						display: flex;
						align-items: center;
						margin-top: 16rpx;
						.active {
							color: #ffffff !important;
						}
						.label_item {
							flex: 1;
							display: flex;
							justify-content: center;
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: rgba(255,255,255,0.7);
						}
					}
				}
			}
		}
		.order_info {
			width: 100%;
			padding: 28rpx 34rpx;
			background: #FFFFFF;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			.order_info_item1 {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.order_info_item1_left {
					display: flex;
					flex-direction: column;
					text {
						&:nth-child(1) {
							font-size: 32rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
						}
						&:nth-child(2) {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
							margin-top: 20rpx;
						}
					}
				}
				.order_info_item1_sub {
					width: 180rpx;
					height: 60rpx;
					line-height: 60rpx;
					text-align: center;
					border-radius: 34rpx;
					border: 2rpx solid #D20A0A;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #D20A0A;
				}
			}
			.order_info_item {
				display: flex;
				align-items: center;
				flex-direction: column;
				padding-bottom: 62rpx;
				.order_info_item_top {
					width: 100%;
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-size: 32rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
							margin-right: 12rpx;
						}
						&:nth-child(2) {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
						}
					}
				}
				.order_info_item_bottom {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 20rpx;
					text {
						&:nth-child(1) {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
						&:nth-child(2) {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
					}
				}
			}
		}
		.order_shop {
			width: 100%;
			padding: 40rpx 32rpx 28rpx 32rpx;
			background-color: #FFFFFF;
			margin-top: 16rpx;
			box-sizing: border-box;
			.order_shop_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 32rpx;
			}
			.order_shop_info {
				display: flex;
				align-items: flex-start;
				.order_shop_info_img {
					flex-shrink: 0;
					width: 180rpx;
					height: 180rpx;
					background: #FFFFFF;
					border-radius: 12rpx;
					border: 2rpx solid #F5F5F5;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 20rpx;
					image {
						width: 160rpx;
						height: 160rpx;
					}
				}
				.order_shop_info_right {
					flex: 1;
					display: flex;
					flex-direction: column;
					.order_shop_info_right_top {
						display: flex;
						align-items: center;
						justify-content: space-between;
						.title {
							width: 320rpx;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.price {
							display: flex;
							align-items: center;
							text {
								&:nth-child(1) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 8rpx;
								}
								&:nth-child(2) {
									font-size: 28rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
								}
								&:nth-child(3) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 8rpx;
								}
							}
						}
					}
					.order_shop_info_right_bottom {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 16rpx;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
				}
			}
			.order_shop_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 40rpx;
				.nottop {
					margin-top: 0 !important;
				}
				.order_shop_list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 28rpx;
					&:first-child {
						margin-top: 0 !important;
					}
					.label {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
					.time {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
					.price {
						font-size: 24rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #D20A0A;
					}
					.copy {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #999999;
							}
							&:nth-child(2) {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #999999;
								margin: 0 8rpx;
							}
							&:nth-child(3) {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
							}
						}
					}
					.price_h {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 20rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
								margin-top: 8rpx;
							}
							&:nth-child(2) {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
							}
							&:nth-child(3) {
								font-size: 20rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
								margin-top: 8rpx;
							}
						}
					}
					input {
						width: 336rpx;
						text-align: right;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #000000;
					}
				}
			}
		}
		.order_footer {
			width: 100%;
			background-color: #FFFFFF;
			box-sizing: border-box;
			position: fixed;
			bottom: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 20rpx 32rpx calc(20rpx + env(safe-area-inset-bottom)) 32rpx;
			.order_footer_left {
				font-size: 28rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
			.order_footer_right {
				display: flex;
				align-items: center;
				.order_footer_right_btn {
					width: 144rpx;
					height: 52rpx;
					line-height: 52rpx;
					text-align: center;
					border-radius: 30rpx;
					border: 2rpx solid #D9D9D9;
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
					margin-right: 16rpx;
				}
				.margin {
					margin-right: 0 !important;
				}
			}
		}
		.order_zw {
			width: 100%;
			height: calc(92rpx + env(safe-area-inset-bottom));
		}
		.order_refuse {
			display: flex;
			flex-direction: column;
			padding: 28rpx 34rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			text {
				&:nth-child(1) {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
				&:nth-child(2) {
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					margin-top: 20rpx;
				}
				&:nth-child(3) {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					margin-top: 20rpx;
				}
			}
		}
		.order_success {
			display: flex;
			flex-direction: column;
			padding: 28rpx 34rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			.order_success_top {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 18rpx;
				.order_success_top_left {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #D20A0A;
				}
				.order_success_top_right {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
							margin-top: 11rpx;
						}
						&:nth-child(2) {
							font-size: 40rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
						}
						&:nth-child(3) {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
							margin-top: 11rpx;
						}
					}
				}
			}
			.order_success_info {
				display: flex;
				flex-direction: column;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					&:first-child {
						margin-bottom: 20rpx;
					}
				}
			}
			.order_success_item {
				width: 100%;
				height: 84rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 2rpx solid #F4F5F4;
				&:last-child {
					border: none !important;
				}
				.order_success_item_label {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
				}
				.order_success_item_price {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-size: 20rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
							margin-top: 8rpx;
						}
						&:nth-child(2) {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
						}
						&:nth-child(3) {
							font-size: 20rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
							margin-top: 8rpx;
						}
					}
				}
			}
		}
		.order_jijian {
			width: 100%;
			padding: 28rpx 34rpx;
			background: #FFFFFF;
			box-sizing: border-box;
			.top {
				display: flex;
				flex-direction: column;
				text {
					&:nth-child(1) {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					&:nth-child(2) {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
						margin-top: 20rpx;
					}
				}
			}
			.label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.content {
				margin-top: 28rpx;
				padding: 28rpx 24rpx;
				box-sizing: border-box;
				background-color: #F5F5F5;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.content_lefta {
					width: 550rpx;
					margin-right: 46rpx;
					display: flex;
					flex-direction: column;
					text {
						&:nth-child(1) {
							width: 100%;
							text-overflow: ellipsis;
							overflow: hidden;
							white-space: nowrap;
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							text {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
							}
						}
						&:nth-child(2) {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							margin-top: 12rpx;
						}
					}
				}
				.content_left {
					margin-right: 50rpx;
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
						}
					}
				}
			}
		}
	}
</style>